export default {
    name: 'uat',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getProjectDetails: async (context,payload) => {
            return await axios.get(`${synergy4}api/devprojects/get-project-by-name?projectName=${payload}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err
            })
        },
        getAllUat: async (context) => {
            return await axios.get(`${synergy4}UAT/getUATs`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        getUatByProjectName: async (context,payload) => {
            return await axios.get(`${synergy4}UAT/project/${payload}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err
            })
        },
        getUatByStatus: async (context, status) => {
            const {from,to} = context.getters.getGlobalDateRange;
            return await axios.get(`${synergy4}UAT/getUATsByStatus?status=${status}&from=${from}&to=${to}`)
                .then(({data})=>data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        getUATFeaturesByUatId: async (context, id) => {
            return await axios.get(`${synergy4}UAT/getUATFeaturesByUatId/${id}`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        GetProjectDetails: async (context) => {
            return await axios.get(`${synergy4}UAT/GetProjectDetails`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        getUATFeatures: async (context) => {
            return await axios.get(`${synergy4}UAT/getUATFeatures`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        updateUatStatus: async (context,{uatId, status, user}) => {
            return await axios.post(`${synergy4}UAT/uat/update-status?uatId=${uatId}&newStatus=${status}&approvedBy=${user.id}`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        updateFeatureStatus: async (context,{featureId, status}) => {
            return await axios.put(`${synergy4}UAT/features/${featureId}/status?status=${status}`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        addFeatureVedio: async (context,payload) => {
            const url = `${synergy}UAT/upload-feature-video-chunks`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        createUat: async (context,payload) => {
            const url = `${synergy4}UAT/createUat`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        createUatFeature: async (context,payload) => {
            const url = `${synergy4}UAT/createUatFeature`;
            return await context.dispatch('sendRequest',{url,payload})
        },
    }
}
